import Vue from 'vue'
import VueI18n from 'vue-i18n'

import { getLocale } from '@/libs/util'

import ko from './locales/ko'
import en from './locales/en'

Vue.use(VueI18n)

const i18n = new VueI18n({
  messages: {
    ko,
    en
  },
  silentFallbackWarn: true,
  locale: getLocale()
})

export default i18n
